import {Map} from 'immutable';

import * as action from '../actions';

const initialState = Map({
	info: Map({}),
	findForm: Map({
		loading: false,
		data: Map({}),
	}),
	createForm: Map({
		loading: false,
		data: Map({}),
	}),
});

const actionHandlers = {
	// Отправка формы
	[action.findCard.request]: (state, {findForm}) => {
		return state
			.setIn(['findForm', 'loading'], true)
			.setIn(['findForm', 'data'], Map(findForm));
	},
	[action.findCard.success]: (state, {response}) => {
		return state
			.setIn(['findForm', 'loading'], false)
			.setIn(['findForm', 'data'], Map({}))
			.setIn(['info'], Map(response));
	},
	[action.findCard.failure]: state => {
		return state
			.setIn(['findForm', 'loading'], false);
	},

	// Отправка формы
	[action.createCard.request]: (state, {createForm}) => {
		return state
			.setIn(['createForm', 'loading'], true)
			.setIn(['createForm', 'data'], Map(createForm));
	},
	[action.createCard.success]: (state, {response}) => {
		return state
			.setIn(['createForm', 'loading'], false)
			.setIn(['createForm', 'data'], Map({}))
			.setIn(['info'], Map(response));
	},
	[action.createCard.failure]: state => {
		return state
			.setIn(['createForm', 'loading'], false);
	},

	[action.clearCardInfo]: state => {
		return state
			.setIn(['info'], Map({}));
	},
};

export {initialState, actionHandlers};
export default createReducer => createReducer(initialState, actionHandlers);



// WEBPACK FOOTER //
// ./src/reducers/cardReducer.js